import { render, staticRenderFns } from "./OrgUnitSearch.vue?vue&type=template&id=1822a9f0&scoped=true"
import script from "./OrgUnitSearch.vue?vue&type=script&lang=js"
export * from "./OrgUnitSearch.vue?vue&type=script&lang=js"
import style0 from "./OrgUnitSearch.vue?vue&type=style&index=0&id=1822a9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1822a9f0",
  null
  
)

export default component.exports